// Mobile back-button support for dismissible overlays.
//
// One ghost history entry backs a stack of layers (drawer, sheets, lightbox).
// The browser "atrás" closes the topmost layer instead of leaving the page, and
// closing a layer by UI discards its ghost entry so a single back still leaves.
const MOBILE_QUERY = '(max-width: 959.98px)'
const STACK_KEY = '__dycarMobileBackStack'

function isMobile (win) {
  if (typeof win.matchMedia === 'function') return !!win.matchMedia(MOBILE_QUERY).matches
  return Number(win.innerWidth) > 0 && Number(win.innerWidth) < 960
}

function createStack (win) {
  const layers = []
  let listening = false
  let ghost = false
  let silent = false

  function pushGhost () {
    win.history.pushState(null, '', win.location && win.location.href ? win.location.href : undefined)
    ghost = true
  }

  function detach () {
    if (!listening) return
    listening = false
    win.removeEventListener('popstate', onPop)
  }

  function attach () {
    if (listening) return
    listening = true
    win.addEventListener('popstate', onPop)
  }

  function onPop () {
    if (silent) {
      // This popstate consumed a ghost entry discarded by a UI close.
      silent = false
      ghost = false
      if (!layers.length) detach()
      return
    }
    ghost = false
    const top = layers[layers.length - 1]
    if (!top) { detach(); return }
    top.dismiss()
    // Vue watchers unregister the layer on the next flush; re-arm afterwards.
    Promise.resolve().then(() => {
      if (!layers.length) { detach(); return }
      if (!ghost) pushGhost()
    })
  }

  return {
    register (dismiss) {
      if (!isMobile(win) || !win.history || typeof win.history.pushState !== 'function') return null
      const layer = { dismiss }
      layers.push(layer)
      attach()
      if (!ghost) pushGhost()
      return layer
    },
    unregister (layer, options) {
      if (!layer) return
      const index = layers.indexOf(layer)
      if (index < 0) return
      layers.splice(index, 1)
      if (layers.length) return
      if (options && options.keepHistory) {
        ghost = false
        detach()
        return
      }
      if (!ghost) { detach(); return }
      // Consume the ghost entry without dismissing anything. The listener stays
      // attached to swallow the resulting popstate, then detaches itself.
      ghost = false
      silent = true
      win.history.back()
    }
  }
}

export function getMobileBack (win) {
  if (!win) return null
  if (!win[STACK_KEY]) win[STACK_KEY] = createStack(win)
  return win[STACK_KEY]
}

// Same breakpoint the app uses for its mobile layout (< 960px).
export function isMobileViewport (win) {
  if (!win) return false
  return isMobile(win)
}
